const size = {
    rem: {
        xs: "76.8",
        s: "128",
        m: "144",
        l: "192"
    },
    px: {
        xs: "768",
        sxs: "1100",
        s: "1280",
        m: "1440",
        l: "1920"
    }
};

const theme = {
    "color-white": "#FFF",
    "color-black": "#000",
    "color-grey": "#686666",
    "color-light-grey": "#F7F7F7",
    "color-blue": "#27B2FF",
    "color-dark-blue": "#0075A6",
    "color-location-blue": "#239FE4",
    "color-class-blue": "#EBF6FF",
    "color-class-grey": "#F7F7F7",
    "color-class-green": "#E8F5E8",
    "color-light-yellow": "#FFF6E5",
    "color-price-yellow": "#E4C823",
    "color-light-purple": "#F7F2FF",
    "color-price-purple": "#9A00FC",
    "color-faq-purple": "#B372FD",

    "spacing-s": "5px",
    "spacing-sm": "10px",
    "spacing-m": "16px",
    "spacing-ml": "20px",
    "spacing-l": "32px",
    "spacing-lxl": "40px",
    "fontsize-xs": "12px",
    "fontsize-s": "14px",
    "fontsize-m": "16px",
    "fontsize-l": "20px",
    "fontsize-lxl": "30px",
    "fontsize-xl": "50px",
    "border-radius": "25px",

    "navbar-height": "80px",
    "navbar-logo-height": 30
} as const;

export type Theme = typeof theme;

export { size, theme };
